module.exports = __webpack_public_path__ + "media/images/emblems/Kilchberg-blazon-ae2e23851cbb05ca8e3892c06c5e5809.svg";